import {
  all,
  call,
  fork,
  put,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import request from "../util/request";
import {
  fetch_kpi_data_success,
  fetch_kpi_data_failed,
  fetch_s3_kpi_data_success,
  fetch_s3_kpi_data_failed,
  fetch_tv_kpi_data_success,
  fetch_tv_kpi_data_failed,
  fetch_available_kpis_success,
  fetch_available_kpis_failed,
  fetch_nights_available_success,
  fetch_nights_available_failed,
  get_kpi_summary_success,
  get_kpi_summary_failed,
  get_ml_kpi_summary_success,
  get_ml_kpi_summary_failed,
  fetch_annotations as fetch_annotations_action,
  fetch_annotations_success,
  fetch_annotations_failed,
  add_new_annotation_success,
  add_new_annotation_failed,
  edit_annotation_success,
  edit_annotation_failed,
  fetch_annotation_categories as fetch_annotation_categories_action,
  fetch_annotation_categories_success,
  fetch_annotation_categories_failed,
  fetch_patients_rii_summary as fetch_patients_rii_summary_action,
  fetch_patients_rii_summary_success,
  fetch_patients_rii_summary_failed,
  add_annotation_category_success,
  add_annotation_category_failed,
  edit_annotation_category_success,
  edit_annotation_category_failed,
  delete_annotation_category_success,
  delete_annotation_category_failed,
  generate_system_annotations_success,
  generate_system_annotations_failed,
  update_kpi_preference_success,
  update_kpi_preference_failed,
  update_trendview_kpi_preference_success,
  update_trendview_kpi_preference_failed,
  fetch_patient_jira_cards_data_success,
  fetch_patient_jira_cards_data_failed,
  fetch_actigraph_success,
  fetch_actigraph_failed,
} from "actions/kpi";

import {
  FETCH_KPI_DATA,
  FETCH_TV_KPI_DATA,
  FETCH_AVAILABLE_KPIS,
  FETCH_NIGHTS_AVAILABLE,
  GET_KPI_SUMMARY,
  GET_ML_KPI_SUMMARY,
  FETCH_ANNOTATIONS,
  FETCH_PATIENTS_RII_SUMMARY,
  ADD_NEW_ANNOTATION,
  EDIT_ANNOTATION,
  DELETE_ANNOTATIONS,
  FETCH_ANNOTATION_CATEGORIES,
  ADD_ANNOTATION_CATEGORY,
  EDIT_ANNOTATION_CATEGORY,
  DELETE_ANNOTATION_CATEGORY,
  GENERATE_SYSTEM_ANNOTATIONS,
  UPDATE_KPI_PREFERENCE,
  UPDATE_TRENDVIEW_KPI_PREFERENCE,
  FETCH_PATIENT_JIRA_CARDS_DATA,
  FETCH_S3_KPI_DATA,
  FETCH_ACTIGRAPH,
} from "constants/ActionTypes";
import {
  fetchS3KpiData,
  fetchAnnotationsFromS3,
  fetchS3KpiDataByDateRange,
} from "util/helpers";

function* fetch_kpi_data_saga({ payload }) {
  try {
    let {
      graph_type,
      recording_date,
      device_start_time,
      device_stop_time,
      patient_id,
      device_id,
    } = payload;

    const response = yield call(request, {
      path: `/analytics/patient/type=${graph_type}?device_start_time=${device_start_time}&device_stop_time=${device_stop_time}&recording_date=${recording_date}&patient_id=${patient_id}&device_id=${device_id}`,
      method: "GET",
    });

    if (response.status === 200) {
      yield put(fetch_kpi_data_success(response.data, graph_type));
    } else {
      yield put(fetch_kpi_data_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_s3_kpi_data_saga({ payload }) {
  try {
    let {
      graph_type,
      multiple,
      // recording_date,
      // device_start_time,
      // device_stop_time,
      // patient_id,
      // device_id,
    } = payload;

    const response = yield call(fetchS3KpiData, payload);

    if (response.status === 200) {
      yield put(
        fetch_s3_kpi_data_success(
          {
            kpi: graph_type,
            recording_meta: response.recording_meta,
            data: response.data,
            multiple,
          },
          graph_type
        )
      );
      return response;
    } else {
      yield put(fetch_s3_kpi_data_failed());
      return null;
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_tv_kpi_data_saga({ payload }) {
  try {
    const {
      patient_id,
      graph_type,
      device_start_time,
      device_stop_time,
    } = payload;

    const response = yield call(request, {
      path: `/analytics/patient-trendview/type=${graph_type}?device_start_time=${device_start_time}&device_stop_time=${device_stop_time}&patient_id=${patient_id}`,
      method: "GET",
    });

    if (response.status === 200) {
      yield put(
        fetch_tv_kpi_data_success({
          ...payload,
          ...response.data,
        })
      );
    } else {
      yield put(fetch_tv_kpi_data_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_available_kpis_saga({ payload }) {
  try {
    const response = yield call(fetch_s3_kpi_data_saga, { payload });

    if (response.status === 200) {
      const displayKPILIST = [
        "SLP_STGS",
        "Y_DIST",
        "MOV",
        "BR",
        "BRV",
        "HR",
        "HRV",
        "SPO2",
        "PR",
        "I",
        "Q",
        "SA",
        "TB",
        "bp",
        "blood_sugar",
        "body_temp",
        "NC_PSG",
        "THRX_PSG",
        "ABD_PSG",
        "SPO2_PSG",
      ];
      const available_kpis = response.data.map((item) => item.kpi);

      const sortedKpiList = displayKPILIST.filter(
        (v) => -1 !== available_kpis.indexOf(v)
      );
      const nonGraphKpiList = ["SQB", "AHI", "AP_timing", "DSAT"].filter(
        (v) => -1 !== available_kpis.indexOf(v)
      );

      yield put(
        fetch_available_kpis_success({
          available_kpis: sortedKpiList,
          non_graph_available_kpis: nonGraphKpiList,
        })
      );
    } else {
      yield put(fetch_available_kpis_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_nights_available_saga({ payload }) {
  try {
    const { user_id } = payload;

    const response = yield call(request, {
      path: `/patient/available-nights?patient_id=${user_id}`,
      method: "GET",
    });

    if (response.status === 200) {
      yield put(fetch_nights_available_success(response.data));
    } else {
      yield put(fetch_nights_available_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_actigraph_saga({ payload }) {
  try {
    const { start_date, end_date, patient_id, device_id } = payload;

    const response = yield call(fetchS3KpiDataByDateRange, {
      start_date,
      end_date,
      patient_id,
      device_id,
    });

    yield put(fetch_actigraph_success(response));
  } catch (error) {
    console.error(error);
    yield put(fetch_actigraph_failed());
  }
}

function* get_kpi_summary_saga({ payload }) {
  try {
    const { kpi, recording_date, device_allocation_time, device_id } = payload;

    const response = yield call(request, {
      path: `/analytics/patient/summary/kpi=${kpi}?recording_date=${recording_date}&device_allocation_time=${device_allocation_time}&device_id=${device_id}`,
      method: "GET",
    });

    if (response.status === 200) {
      yield put(get_kpi_summary_success(response.data));
    } else {
      yield put(get_kpi_summary_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* get_ml_kpi_summary_saga({ payload }) {
  try {
    const { patient_id, recording_date } = payload;

    const response = yield call(request, {
      path: `/analytics/patient/summary/kpi=ML_KPI_SUMMARY?patient_id=${patient_id}&recording_date=${recording_date}`,
      method: "GET",
    });

    if (response.status === 200) {
      yield put(get_ml_kpi_summary_success(response.data));
    } else {
      yield put(get_ml_kpi_summary_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_annotations_saga({ payload }) {
  try {
    const response = yield call(fetchAnnotationsFromS3, payload);
    const { data } = response;

    if (response.status === 200) {
      yield put(fetch_annotations_success({ ...data }));
    } else {
      yield put(fetch_annotations_failed());
    }
  } catch (error) {
    yield put(fetch_annotations_failed());
    console.error(error);
  }
}

function* delete_annotations_saga({ payload }) {
  const {
    doctor_id,
    patient_id,
    kpi,
    night,
    ids,
    recording_date,
    device_id,
  } = payload;
  try {
    const response = yield call(request, {
      path: `/analytics/patient/delete-annotations`,
      method: "POST",
      body: JSON.stringify({ ids }),
    });
    if (response.status === 200) {
      yield put(
        fetch_annotations_action({
          doctor_id,
          patient_id,
          kpi,
          night,
          recording_date,
          device_id,
        })
      );
      yield put(
        fetch_patients_rii_summary_action({
          night,
          patient_id,
          device_id,
        })
      );
    } else {
      yield put(fetch_annotations_failed());
    }
  } catch (error) {
    console.error("delete_annotations_saga-->  ", error);
  }
}

function* fetch_patients_rii_summary_saga({ payload }) {
  try {
    const { night, patient_id, device_id } = payload;
    const response = yield call(request, {
      path: `/patient/rii_odi_value?night=${night}&patient_id=${patient_id}&device_id=${device_id}`,
      method: "GET",
    });
    if (response.status === 200) {
      yield put(fetch_patients_rii_summary_success(response.data));
    } else {
      yield put(fetch_patients_rii_summary_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

function* add_new_annotation_saga({ payload }) {
  try {
    const { recording_date, device_id, ...rest } = payload;
    const response = yield call(request, {
      path: `/analytics/patient/new-annotations`,
      method: "POST",
      body: JSON.stringify(rest),
    });

    if (response.status === 200) {
      yield put(add_new_annotation_success(response.data));
      const { doctor_id, patient_id, kpi, night } = payload;

      yield put(
        fetch_annotations_action({
          doctor_id,
          patient_id,
          kpi,
          night,
          recording_date,
          device_id,
        })
      );
      yield put(
        fetch_patients_rii_summary_action({
          night,
          patient_id,
          device_id,
        })
      );
    } else {
      yield put(add_new_annotation_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* edit_annotation_saga({ payload }) {
  try {
    const { device_id, recording_date, ...rest } = payload;
    const response = yield call(request, {
      path: `/analytics/patient/update-annotations`,
      method: "POST",
      body: JSON.stringify(rest),
    });

    if (response.status === 200) {
      yield put(edit_annotation_success(response.data));

      const { doctor_id, patient_id, kpi, night } = payload;

      yield put(
        fetch_annotations_action({
          doctor_id,
          patient_id,
          kpi,
          night,
          device_id,
          recording_date,
        })
      );
      yield put(
        fetch_patients_rii_summary_action({
          night,
          patient_id,
          device_id,
        })
      );
    } else {
      yield put(edit_annotation_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_annotation_categories_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/get-label-list`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    const { data } = response;

    if (response.status === 200) {
      yield put(
        fetch_annotation_categories_success({ annotation_categories: data })
      );
    } else {
      yield put(fetch_annotation_categories_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* add_annotation_category_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/add-label`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      yield put(add_annotation_category_success(response.data));

      const { doctor_id } = payload;

      yield put(fetch_annotation_categories_action({ doctor_id }));
    } else {
      yield put(add_annotation_category_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* edit_annotation_category_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/update-label`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      yield put(edit_annotation_category_success(response.data));

      const { doctor_id } = payload;

      yield put(fetch_annotation_categories_action({ doctor_id }));
    } else {
      yield put(edit_annotation_category_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* delete_annotation_category_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/delete-label`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      yield put(delete_annotation_category_success(response.data));

      const { doctor_id } = payload;

      yield put(fetch_annotation_categories_action({ doctor_id }));
    } else {
      yield put(delete_annotation_category_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* generate_system_annotations_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/analytics/patient/generate-system-annotations`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (response.status === 200) {
      yield put(generate_system_annotations_success(response.data));

      const {
        type,
        kpi,
        device_id,
        recording_date,
        doctor_id,
        patient_id,
        night,
      } = payload;

      yield put(
        fetch_annotations_action({
          type,
          kpi,
          doctor_id,
          patient_id,
          night,
          recording_date,
          device_id,
        })
      );
    } else {
      yield put(generate_system_annotations_failed());
    }
  } catch (error) {
    console.error(error);
  }
}

function* update_kpi_preference_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/update-kpi-preferences`,
      method: "POST",
      body: JSON.stringify(payload),
    });
    const { data = {} } = response;
    if (response.status === 200) {
      yield put(update_kpi_preference_success(data));
    } else {
      yield put(update_kpi_preference_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}
function* update_trendview_kpi_preference_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/patient/update-trendview-kpi-preference`,
      method: "POST",
      body: JSON.stringify(payload),
    });
    const { data = {} } = response;
    if (response.status === 200) {
      yield put(update_trendview_kpi_preference_success(data));
    } else {
      yield put(update_trendview_kpi_preference_failed(response.message));
    }
  } catch (error) {
    console.error(error);
  }
}

function* fetch_patient_jira_cards_saga({ payload }) {
  try {
    const { patient_code } = payload;

    const response = yield call(request, {
      path: `/patient/fetch_patient_jira_cards?patient_code=${patient_code}`,
      method: "GET",
    });
    const { data } = response;
    if (response.status === 200) {
      yield put(fetch_patient_jira_cards_data_success(data));
    } else {
      yield put(fetch_patient_jira_cards_data_failed(response.message));
    }
  } catch (error) {
    console.log(error);
  }
}
export function* fetch_kpi_data() {
  yield takeLatest(FETCH_KPI_DATA, fetch_kpi_data_saga);
}

export function* fetch_s3_kpi_data() {
  yield takeLatest(FETCH_S3_KPI_DATA, fetch_s3_kpi_data_saga);
}

export function* fetch_tv_kpi_data() {
  yield takeLatest(FETCH_TV_KPI_DATA, fetch_tv_kpi_data_saga);
}

export function* fetch_available_kpis() {
  yield takeLatest(FETCH_AVAILABLE_KPIS, fetch_available_kpis_saga);
}

export function* fetch_nights_available() {
  yield takeLatest(FETCH_NIGHTS_AVAILABLE, fetch_nights_available_saga);
}

export function* fetch_actigraph() {
  yield takeLatest(FETCH_ACTIGRAPH, fetch_actigraph_saga);
}

export function* get_kpi_summary() {
  yield takeLatest(GET_KPI_SUMMARY, get_kpi_summary_saga);
}

export function* fetch_annotations() {
  yield takeEvery(FETCH_ANNOTATIONS, fetch_annotations_saga);
}

export function* fetch_patients_rii_summary() {
  yield takeEvery(FETCH_PATIENTS_RII_SUMMARY, fetch_patients_rii_summary_saga);
}

export function* delete_annotations() {
  yield takeLatest(DELETE_ANNOTATIONS, delete_annotations_saga);
}

export function* get_ml_kpi_summary() {
  yield takeLatest(GET_ML_KPI_SUMMARY, get_ml_kpi_summary_saga);
}

export function* add_new_annotation() {
  yield takeEvery(ADD_NEW_ANNOTATION, add_new_annotation_saga);
}

export function* edit_annotation() {
  yield takeEvery(EDIT_ANNOTATION, edit_annotation_saga);
}

export function* fetch_annotation_categories() {
  yield takeLatest(
    FETCH_ANNOTATION_CATEGORIES,
    fetch_annotation_categories_saga
  );
}

export function* add_annotation_category() {
  yield takeLatest(ADD_ANNOTATION_CATEGORY, add_annotation_category_saga);
}

export function* edit_annotation_category() {
  yield takeLatest(EDIT_ANNOTATION_CATEGORY, edit_annotation_category_saga);
}

export function* delete_annotation_category() {
  yield takeLatest(DELETE_ANNOTATION_CATEGORY, delete_annotation_category_saga);
}

export function* generate_system_annotations() {
  yield takeLatest(
    GENERATE_SYSTEM_ANNOTATIONS,
    generate_system_annotations_saga
  );
}

export function* update_kpi_preference() {
  yield takeLatest(UPDATE_KPI_PREFERENCE, update_kpi_preference_saga);
}

export function* update_trendview_kpi_preference() {
  yield takeLatest(
    UPDATE_TRENDVIEW_KPI_PREFERENCE,
    update_trendview_kpi_preference_saga
  );
}

export function* fetch_patient_jira_cards_data() {
  yield takeLatest(
    FETCH_PATIENT_JIRA_CARDS_DATA,
    fetch_patient_jira_cards_saga
  );
}

export default function* rootSaga() {
  yield all([
    fork(fetch_nights_available),
    fork(fetch_available_kpis),
    fork(fetch_kpi_data),
    fork(fetch_s3_kpi_data),
    fork(fetch_tv_kpi_data),
    fork(fetch_actigraph),
    fork(get_kpi_summary),
    fork(get_ml_kpi_summary),
    fork(fetch_annotations),
    fork(fetch_patients_rii_summary),
    fork(add_new_annotation),
    fork(edit_annotation),
    fork(delete_annotations),
    fork(fetch_annotation_categories),
    fork(add_annotation_category),
    fork(edit_annotation_category),
    fork(delete_annotation_category),
    fork(generate_system_annotations),
    fork(update_kpi_preference),
    fork(update_trendview_kpi_preference),
    fork(fetch_patient_jira_cards_data),
  ]);
}
